"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const TypographyComponent = (_a) => {
    var { typographyType, children } = _a, props = __rest(_a, ["typographyType", "children"]);
    switch (typographyType) {
        case 'h1':
            return (0, jsx_runtime_1.jsx)("h1", Object.assign({}, props, { children: children }));
        case 'h2':
            return (0, jsx_runtime_1.jsx)("h2", Object.assign({}, props, { children: children }));
        case 'h3':
            return (0, jsx_runtime_1.jsx)("h3", Object.assign({}, props, { children: children }));
        case 'h4':
            return (0, jsx_runtime_1.jsx)("h4", Object.assign({}, props, { children: children }));
        case 'h5':
            return (0, jsx_runtime_1.jsx)("h5", Object.assign({}, props, { children: children }));
        case 'h6':
            return (0, jsx_runtime_1.jsx)("h6", Object.assign({}, props, { children: children }));
        case 'small':
            return ((0, jsx_runtime_1.jsx)("small", Object.assign({}, props, { style: Object.assign(Object.assign({}, props.style), { fontSize: '12px' }) }, { children: children })));
        case 'bold':
            return ((0, jsx_runtime_1.jsx)("small", Object.assign({}, props, { style: Object.assign(Object.assign({}, props.style), { fontWeight: 'bold', fontSize: '14px' }) }, { children: children })));
        default:
            return (0, jsx_runtime_1.jsx)("h6", Object.assign({}, props, { children: children }));
    }
};
exports.default = TypographyComponent;
